import { api } from "./client";

// Corrections of event data found by a check; applied only when the admin accepts one.
export const DataQualityAPI = {
  list: async (status = "PENDING") => {
    const { data } = await api.get("/api/admin/data-quality/proposals", { params: { status } });
    return Array.isArray(data) ? data : [];
  },

  /** For a duplicate, keepOther keeps the proposed duplicate and removes the other entry. */
  accept: async (id, { keepOther = false } = {}) => {
    const { data } = await api.post(`/api/admin/data-quality/proposals/${id}/accept`, null, {
      params: keepOther ? { keepOther: true } : undefined,
    });
    return data;
  },

  reject: async (id) => {
    const { data } = await api.post(`/api/admin/data-quality/proposals/${id}/reject`);
    return data;
  },
};
